import React, { useState, useMemo, useEffect, useRef } from 'react';
import { get, isEmpty } from 'lodash';

import api, { apiV2 } from '../src/services/api';
import Head from 'next/head';
import Error404 from '../src/pages/Errors/Error404';
import ErrorFinished from '../src/pages/Errors/ErrorFinished';
import ErrorExipred from '../src/pages/Errors/ErrorExipred';
import Router from 'next/router';
import withGA from 'next-ga';
import { parseISO, isBefore } from 'date-fns';
import { Menu } from '../src/components/Menu';
import { NewBanner } from '../src/components/NewBanner';
import {
  Container,
  Card,
  Row,
  Title,
  Tag,
  TitleItems,
  DescriptionsText,
  ModalShare,
} from '../src/pages/DetailJob/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAccessibleIcon } from '@fortawesome/free-brands-svg-icons';
import {
  faAngleLeft,
  faBriefcase,
  faBuilding,
  faMapMarked,
  faMoneyBill,
  faShareNodes,
  faTimes,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { iconsFa } from './../src/utils/iconsFa';
import parse from 'html-react-parser';
import { FaRegCheckCircle } from 'react-icons/fa';
import { NewFooter } from './../src/components/NewFooter';
import { SendCurriculum } from './../src/components/SendCurriculum';
import ShareVacancy from './../src/components/ShareVacancy';
import RelatedVacancies from '../src/components/RelatedVacancies';

var canonical;
var job_location, job_location_type, validThrough;

// Função utilitária para montar a URL de candidatura corretamente
function buildSignupUrl(baseUrl, params = {}) {
  const queryParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`);
  if (queryParams.length === 0) return baseUrl;
  return `${baseUrl}?${queryParams.join('&')}`;
}

function Details({ retorno }) {
  const [showModalShare, setShowModalShare] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const modalShownRef = useRef(false);
  const skill = retorno?.vacancy?.skills
    ?.split(',')
    .map(tech => tech.trim())
    .filter(a => a !== '');
  const skillFilter = skill?.filter(a => a !== '');

  const benefit = retorno?.vacancy?.benefits
    ?.split(',')
    .map(tech => tech.trim());
  const benefitFilter = benefit?.filter(a => a !== '');

  // Função para formatar o valor do campo baseado no tipo
  const formatCustomFieldData = (field) => {
    // Verifica se o valor é um boolean (true ou false, não string)
    if (typeof field.field_data === 'boolean') {
      return field.field_data === true ? 'Sim' : 'Não';
    }
    // Verifica se o valor é um array
    if (Array.isArray(field.field_data)) {
      return field.field_data.join(', ');
    }
    // Verifica se é uma data no formato ISO (YYYY-MM-DD)
    if (typeof field.field_data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(field.field_data)) {
      const [year, month, day] = field.field_data.split('-');
      return `${day}/${month}/${year}`;
    }
    return field.field_data;
  };

  // Função para renderizar um custom field
  const renderCustomField = (customField, index) => {
    return (
      <div
        key={index}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginTop: '12px',
        }}
      >
        <FontAwesomeIcon 
          icon={faChevronRight} 
          color="#36397A" 
          style={{ 
            width: '14px', 
            height: '14px',
            flexShrink: 0
          }} 
        />
        <span style={{ fontSize: '18px', color: '#485467' }}>
          <strong>{customField.field_name}:</strong> {formatCustomFieldData(customField)}
        </span>
      </div>
    );
  };

  useEffect(() => {
    // Função que detecta se o mouse está saindo da página
    const handleMouseLeave = (e) => {
      // Verifica se o mouse está saindo da janela pela parte superior e se a modal ainda não foi mostrada
      if (e.clientY <= 0 && !showExitModal && window.innerWidth > 768 && !modalShownRef.current) {
        setShowExitModal(true);
        modalShownRef.current = true; // Marca que a modal já foi mostrada
      }
    };

    // Adiciona o evento de mouse leave no documento
    document.addEventListener('mouseleave', handleMouseLeave);

    // Remove o evento quando o componente é desmontado
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [showExitModal]);

  const pageError = () => {
    if (retorno.past) {
      return <ErrorExipred />;
    } else if (retorno.finished) {
      return (
        <ErrorFinished
          label={retorno.company?.company?.label}
          name={retorno.company?.company?.name}
        />
      );
    }
    return <Error404 />;
  };

  const backHref = useMemo(() => {
    return !isEmpty(get(retorno, 'query.label', false)) &&
      !isEmpty(get(retorno, 'query.page_label', false))
      ? `/${retorno.query.label}/${retorno.query.page_label}`
      : `/${retorno.company?.company?.label}`;
  }, [retorno]);

  return (
    <>
      {retorno.error && pageError()}
      {!retorno.error && (
        <>
          <ModalShare showModalShare={showModalShare}>
            <div className="modalShareContent">
              <FontAwesomeIcon
                icon={faTimes}
                style={{ width: '14px', alignSelf: 'end' }}
                onClick={() => setShowModalShare(false)}
              />
              <ShareVacancy retorno={retorno} />
            </div>
          </ModalShare>

          {/* Modal de intenção de saída */}
          {showExitModal && (
            <div 
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
              onClick={() => setShowExitModal(false)}
            >
              <div 
                style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '24px',
                  maxWidth: '500px',
                  width: '90%',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ 
                    width: '14px', 
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    cursor: 'pointer'
                  }}
                  onClick={() => setShowExitModal(false)}
                />
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                  <h2 style={{ color: '#36397A', marginBottom: '16px', fontSize: '24px' }}>
                    Espere um momento!
                  </h2>
                  <p style={{ color: '#485467', fontSize: '16px', lineHeight: '1.5' }}>
                    Não perca esta oportunidade! A vaga de {retorno.vacancy?.title} pode ser perfeita para você.
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <a
                    href={buildSignupUrl(
                      `${process.env.REACT_APP_TALENT_URL}/${retorno.company?.company?.label}/${retorno.vacancy.id}/signup`,
                      {
                        utm_source: retorno.utm_source,
                        utm_campaign: retorno.utm_campaign,
                        utm_medium: 'btn-exit-modal',
                      }
                    )}
                    style={{
                      display: 'inline-block',
                      backgroundColor: retorno.company?.company?.base_hexcolor === '#ffffff' 
                        ? "#000000" 
                        : retorno.company?.company?.base_hexcolor,
                      color: 'white',
                      padding: '12px 24px',
                      borderRadius: '4px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      marginBottom: '16px',
                    }}
                  >
                    Candidatar-se agora
                  </a>
                  <div>
                    <button
                      onClick={() => setShowExitModal(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#667085',
                        cursor: 'pointer',
                        fontSize: '14px',
                      }}
                    >
                      Continuar navegando
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Container>
            <Head>
              <meta charSet="utf-8" />
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
              />
              <meta name="country" content="BR" />
              <meta name="robots" content="max-image-preview:large" />
              <title>
                {`${retorno.vacancy?.title} | ${retorno.company?.company?.name}` ||
                  'Recrutei'}
              </title>
              <link
                rel="icon"
                href={
                  retorno?.favicon_url !== null
                    ? retorno.favicon_url
                    : '/static/logo_recrutei.png'
                }
              />
              <meta name="author" content="Recrutei" />
              <link
                rel="canonical"
                href={
                  `https://jobs.recrutei.com.br/` +
                  retorno.currentLabel +
                  `/vacancy/` +
                  retorno.vacancy?.slug
                }
              />
              <meta
                name="description"
                content={`${retorno.vacancy.description
                  ?.replace(/<[^>]*>?/gm, '')
                  .substring(0, 158)}`}
              />
              <meta
                property="og:description"
                content={`${retorno.vacancy.description?.replace(
                  /<[^>]*>?/gm,
                  ''
                )}`}
              />
              <meta
                property="og:site_name"
                content={`${retorno.company?.company?.name} - Veja Nossas Vagas!`}
              />
              <meta
                property="og:title"
                content={`${retorno.vacancy?.title} - ${(retorno.vacancy
                  ?.show_location === 1 &&
                  (retorno.vacancy?.remote === 1
                    ? `Remoto`
                    : retorno.vacancy?.remote === 2
                    ? retorno.vacancy?.city + ` ou Remoto`
                    : retorno.vacancy?.remote === 3
                    ? retorno.vacancy?.city + ` e Remoto (Híbrido)`
                    : retorno.vacancy?.city)) ||
                  ``}`}
              />
              <meta
                name="image"
                property="og:image"
                content={
                  retorno.vacancy?.image_url
                    ? `${retorno.vacancy?.image_url}`
                    : retorno.banner?.banner?.url
                    ? `${retorno.banner?.banner?.url}`
                    : retorno.company?.company?.banner_url
                    ? `${retorno.company?.company?.banner_url}`
                    : '/static/banner.jpg'
                }
              />

              <meta
                property="twitter:title"
                content={`${retorno.vacancy?.title} - ${(retorno.vacancy
                  ?.show_location === 1 &&
                  (retorno.vacancy?.remote === 1
                    ? `Remoto`
                    : retorno.vacancy?.remote === 2
                    ? retorno.vacancy?.city + ` ou Remoto`
                    : retorno.vacancy?.remote === 3
                    ? retorno.vacancy?.city + ` e Remoto (Híbrido)`
                    : retorno.vacancy?.city)) ||
                  ``}`}
              />
              <meta
                property="twitter:image"
                content={
                  retorno.vacancy?.image_url
                    ? `${retorno.vacancy?.image_url}`
                    : retorno.banner?.banner?.url
                    ? `${retorno.banner?.banner?.url}`
                    : retorno.company?.company?.banner_url
                    ? `${retorno.company?.company?.banner_url}`
                    : '/static/banner.jpg'
                }
              />
              <meta name="twitter:card" content="summary_large_image" />

              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: `{
            "@context": "https://schema.org",
            "@type": "JobPosting",
            "jobBenefits": "${
              retorno.vacancy?.benefits
                ? retorno.vacancy?.benefits.replace(/<[^>]*>?/gm, '')
                : ''
            }",
            "datePosted": "${retorno.vacancy?.published_at ?? ''}",
            "description": "${retorno.vacancy.description?.replace(
              /\"/g,
              "'"
            ) ?? ''}",
            "industry": "${
              retorno.vacancy?.company_department
                ? retorno.vacancy?.company_department?.name.replace(
                    /<[^>]*>?/gm,
                    ''
                  )
                : ''
            }",
            "employmentType": "FULL_TIME",
            "hiringOrganization":{
              "@type":"Organization",
              "name": "${retorno.company?.company?.name.replace(
                /<[^>]*>?/gm,
                ''
              )}",
              "sameAs": "",
              "logo": "${retorno.company?.company?.logo_url}"
            },
            "jobLocation": {
              "@type": "Place",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "${
                  retorno.vacancy?.city
                    ? retorno.vacancy?.city.replace(/<[^>]*>?/gm, '')
                    : retorno.company?.company?.city
                }",
                "addressRegion": "${
                  retorno.vacancy?.state
                    ? retorno.vacancy?.state.replace(/<[^>]*>?/gm, '')
                    : ''
                }",
                "addressCountry": "${
                  retorno.vacancy?.country
                    ? retorno.vacancy?.country.replace(/<[^>]*>?/gm, '')
                    : ''
                }"
              }
            },
            "salaryCurrency": "BRL",
                "skills" : "${
                  retorno.vacancy?.skills
                    ? retorno.vacancy?.skills.replace(/<[^>]*>?/gm, '')
                    : ''
                }",
            "title": "${retorno.vacancy?.title.replace(/<[^>]*>?/gm, '') ||
              null}",
            "workHours": "${retorno.vacancy?.workload || ''}"
          }`,
                }}
              />
            </Head>
            <Menu
              company={retorno.company?.company}
              params={retorno.company?.company?.label}
              isDetail
              retorno={retorno}
            />
            <NewBanner
              company={retorno.company?.company}
              params={retorno.company?.company?.label}
              banner={retorno.banner}
            />

            <Card showModalShare={showModalShare}>
              <div className="container-left">
                <Row>
                  <Title>
                    {retorno.vacancy.title}{' '}
                    {retorno?.vacancy?.pcd === 1 && (
                      <Tag className="pcd">
                        <h3>
                          <FontAwesomeIcon icon={faAccessibleIcon} />
                        </h3>
                      </Tag>
                    )}
                    {get(retorno, 'vacancy.is_inclusive', 0) === 1 && (
                      <span className="inclusive">Vaga afirmativa</span>
                    )}
                  </Title>
                  <div className="container-btn-desktop">
                    <ShareVacancy
                      retorno={retorno}
                      style={{ marginBottom: '31px' }}
                    />
                  </div>
                </Row>
                <Row style={{ marginTop: '8px' }}>
                  <div
                    className="div-info-vacancy"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      gap: '32px',
                    }}
                  >
                    {retorno?.vacancy?.client &&
                      retorno?.vacancy?.show_client === 1 && (
                        <TitleItems>
                          <FontAwesomeIcon icon={faBriefcase} />
                          {retorno?.vacancy?.client?.name}
                        </TitleItems>
                      )}
                    {retorno?.vacancy?.company_department && (
                      <TitleItems>
                        <FontAwesomeIcon
                          icon={faBuilding}
                          style={{ width: '14px' }}
                        />
                        {retorno?.vacancy?.company_department?.name}
                      </TitleItems>
                    )}
                    {retorno?.vacancy?.salary && (
                      <TitleItems>
                        <FontAwesomeIcon icon={faMoneyBill} />
                        {retorno?.vacancy?.salary}
                      </TitleItems>
                    )}
                    {retorno?.vacancy?.show_location === 1 && (
                      <h3>
                        <FontAwesomeIcon icon={faMapMarked} />
                        {(retorno?.vacancy?.show_location === 1 &&
                          (retorno?.vacancy?.remote === 1
                            ? `Remoto`
                            : retorno?.vacancy?.remote === 2
                            ? retorno?.vacancy?.location + ` ou Remoto`
                            : retorno?.vacancy?.remote === 3
                            ? retorno?.vacancy?.location + ` e Remoto (Híbrido)`
                            : retorno?.vacancy?.location)) ||
                          `Não Divulgado`}
                      </h3>
                    )}
                  </div>
                  {retorno?.social?.socialNetwork?.map(social => (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '14px',
                      }}
                    >
                      <a
                        className="link-social"
                        href={social.url}
                        target="_blank"
                      >
                        <FontAwesomeIcon
                          icon={
                            iconsFa.filter(
                              icon => icon.iconName === social.icon
                            )[0]?.icon
                          }
                          color="#667085"
                        />
                      </a>
                    </div>
                  ))}
                </Row>
                <Row
                  style={{ marginTop: '20px' }}
                  onClick={() => setShowModalShare(true)}
                  className="container-btn-mobile"
                >
                  <h3
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    Compartilhe esta vaga{' '}
                    <FontAwesomeIcon icon={faShareNodes} />
                  </h3>
                </Row>
                <Title style={{ marginTop: '24px', fontSize: '22px' }}>
                  Descrição da vaga
                </Title>
                <DescriptionsText>
                  {parse(`${retorno?.vacancy?.description}`)}
                </DescriptionsText>
              </div>
              <div className="container-right">
                {retorno?.vacancy?.workload && retorno?.vacancy?.workload > 1 && (
                  <>
                    <Title style={{ fontSize: '22px' }}>
                      Carga horária semanal
                    </Title>
                    <div
                      style={{
                        display: 'flex',
                        gap: '12px',
                        marginTop: '12px',
                      }}
                    >
                      <FaRegCheckCircle color="#36397A" size={20} />
                      <span
                        style={{
                          fontSize: '18px',
                          color: '#485467',
                        }}
                      >
                        {retorno?.vacancy?.workload} horas
                      </span>
                    </div>
                  </>
                )}
                {retorno?.vacancy?.show_regime === 1 &&
                  ![
                    'Não Informado',
                    'Nenhum',
                    'Não informado',
                    'nenhum',
                  ].includes(retorno?.vacancy?.regime?.description) && (
                    <>
                      <Title style={{ marginTop: '28px', fontSize: '22px' }}>
                        Regime de Contratação
                      </Title>
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          marginTop: '12px',
                        }}
                      >
                        <FaRegCheckCircle color="#36397A" size={20} />
                        <span style={{ fontSize: '18px', color: '#485467' }}>
                          {retorno?.vacancy?.regime?.description}
                        </span>
                      </div>
                    </>
                  )}
                {retorno?.vacancy?.remuneration !== null &&
                  retorno?.vacancy?.show_remuneration === 1 && (
                    <>
                      <Title style={{ marginTop: '28px', fontSize: '22px' }}>
                        Salário
                      </Title>
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          marginTop: '12px',
                        }}
                      >
                        <FaRegCheckCircle color="#36397A" size={20} />
                        <span
                          style={{
                            fontSize: '18px',
                            color: '#485467',
                          }}
                        >
                          {retorno?.vacancy?.fixed_remuneration
                            ? retorno?.vacancy?.remuneration
                              ? `R$${retorno?.vacancy?.remuneration} por ${retorno?.vacancy?.remuneration_type}`
                              : `Não Informado`
                            : retorno?.vacancy?.remuneration_from &&
                              retorno?.vacancy?.remuneration_to
                            ? `De R$${retorno?.vacancy?.remuneration_from} até R$${retorno?.vacancy?.remuneration_to} por ${retorno?.vacancy?.remuneration_type}`
                            : `Não Informado`}
                        </span>
                      </div>
                      {retorno?.vacancy?.commission && (
                        <>
                          <Title
                            style={{ marginTop: '28px', fontSize: '22px' }}
                          >
                            Comissão
                          </Title>
                          <div
                            style={{
                              display: 'flex',
                              gap: '12px',
                              marginTop: '12px',
                            }}
                          >
                            <FaRegCheckCircle color="#36397A" size={20} />
                            <span
                              style={{
                                fontSize: '18px',
                                color: '#485467',
                              }}
                            >
                              {retorno?.vacancy?.commission}
                            </span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                {skillFilter && (
                  <>
                    <Title style={{ marginTop: '28px', fontSize: '22px' }}>
                      Conhecimentos e Habilidades necessárias
                    </Title>
                    {skillFilter.map(job => (
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          marginTop: '12px',
                        }}
                      >
                        <FaRegCheckCircle color="#36397A" size={20} />
                        <span style={{ fontSize: '18px', color: '#485467' }}>
                          {job}
                        </span>
                      </div>
                    ))}
                  </>
                )}
                {benefitFilter && (
                  <>
                    <Title style={{ marginTop: '28px', fontSize: '22px' }}>
                      Benefícios
                    </Title>
                    {benefitFilter.map(job => (
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          marginTop: '12px',
                        }}
                      >
                        <FaRegCheckCircle color="#36397A" size={20} />
                        <span style={{ fontSize: '18px', color: '#485467' }}>
                          {job}
                        </span>
                      </div>
                    ))}
                  </>
                )}
                {retorno?.vacancy?.custom_fields && retorno?.vacancy?.custom_fields.length > 0 && (
                  <>
                    <Title style={{ marginTop: '28px', fontSize: '22px' }}>
                      Informações Complementares
                    </Title>
                    {retorno.vacancy.custom_fields.map(renderCustomField)}
                  </>
                )}
                <Row
                  className="container-btn-desktop"
                  style={{ justifyContent: 'flex-start', gap: '16px' }}
                  primaryColor={retorno.company?.company?.base_hexcolor === '#ffffff' 
                                    ? "#000000"
                                  : retorno.company?.company?.base_hexcolor
                                }
                >
                  <a
                    className="sendcv"
                    href={buildSignupUrl(
                      `${process.env.REACT_APP_TALENT_URL}/${retorno.company?.company?.label}/${retorno.vacancy.id}/signup`,
                      {
                        utm_source: retorno.utm_source,
                        utm_campaign: retorno.utm_campaign,
                        utm_medium: retorno.utm_medium || 'btn-details-page',
                      }
                    )}
                  >
                    Candidatar-se agora
                  </a>
                  <a className="back" href={backHref}>
                    <FontAwesomeIcon icon={faAngleLeft} />
                    Voltar para Vagas
                  </a>
                </Row>
                <Row
                  className="container-btn-mobile"
                  style={{ justifyContent: 'flex-start', gap: '16px' }}
                  primaryColor={retorno.company?.company?.base_hexcolor === '#ffffff' 
                                  ? "#000000"
                                : retorno.company?.company?.base_hexcolor
                              }
                >
                  <a
                    className="sendcv"
                    href={buildSignupUrl(
                      `${process.env.REACT_APP_TALENT_URL}/${retorno.company?.company?.label}/${retorno.vacancy.id}/signup`,
                      {
                        utm_source: retorno.utm_source,
                        utm_campaign: retorno.utm_campaign,
                        utm_medium: retorno.utm_medium || 'btn-details-page',
                      }
                    )}
                  >
                    Candidatar-se agora
                  </a>
                  <a className="back" href={backHref}>
                    <FontAwesomeIcon icon={faAngleLeft} />
                    Voltar para Vagas
                  </a>
                </Row>
              </div>
            </Card>
            <SendCurriculum
              primaryColor={retorno.company?.company?.base_hexcolor}
              params={retorno.company?.company?.label}
            />
            
            {/* Componente para exibir vagas relacionadas do mesmo departamento */}
            <RelatedVacancies 
              vacancy={retorno.vacancy} 
              company={retorno.company?.company}
              currentLabel={retorno.currentLabel}
              utm_source={retorno.utm_source}
              utm_campaign={retorno.utm_campaign}
              utm_medium={retorno.utm_medium}
            />
            
            <NewFooter />
          </Container>
        </>
      )}
    </>
  );
}

Details.getInitialProps = async ({ req, query }) => {
  try {
    let userAgent;
    let error = false;
    let finished = false;
    let past = false;
    if (req) {
      userAgent = req.headers['user-agent'];
    } else {
      userAgent = navigator.userAgent;
    }
    let isMobile = Boolean(
      userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/
      )
    );
    const id = query.id;
    const utm_source = (query?.utm_source) ? ((Array.isArray(query?.utm_source)) ? query?.utm_source[0] : query?.utm_source) : undefined;
    const utm_campaign = query.utm_campaign;
    const utm_medium = query.utm_medium;
    const slugId = query.slug.split('-');
    const { label, page_label } = query;
    const currentLabel = !isEmpty(label) && !isEmpty(page_label)
      ? `${label}/${page_label}`
      : label;

    const url = !isEmpty(page_label)
      ? `/vacancies/public/${slugId[0]}?utm_source=page:${label}/${page_label}`
      : `/vacancies/public/${slugId[0]}?utm_source=page:${label}`;

    const { data } = await api.get(url);

    const dateAt = `${data?.expired_at} 18:00:00`;
    const parsedDate = parseISO(dateAt);
    past = isBefore(parsedDate, new Date());

    if (data?.vacancy_status_id !== 1) finished = true;

    if (past || finished) {
      error = true;
    }

    // Função helper para fazer requisições de forma segura
    const safeApiRequest = async (url, fallback = null) => {
      try {
        const response = await api.get(url);
        return response;
      } catch (error) {
        console.error(`Failed to fetch ${url}:`, error.message);
        // Log apenas em desenvolvimento
        if (process.env.NODE_ENV === 'development') {
          console.error('Error details:', error);
        }
        return fallback;
      }
    };

    const configurationUrl =
      query?.label && query?.page_label
        ? `pages/sections/configuration/get/${query.label}/${query.page_label}`
        : `pages/sections/configuration/get/${query.label}`;

    const responseConfiguration = await safeApiRequest(configurationUrl);

    // Verificação de segurança para evitar erros quando responseConfiguration é undefined
    const base_hexcolor = responseConfiguration?.data?.data?.hexcolor || data?.company?.base_hexcolor || '#0052CC';

    const logo_url = responseConfiguration?.data?.data?.logo?.url
      ? responseConfiguration.data.data.logo.url
      : data?.company?.logo_url;
    const favicon_url = responseConfiguration?.data?.data?.favicon?.url
      ? responseConfiguration.data.data.favicon.url
      : data?.company?.favicon_url;
    const bannerUrl =
      !isEmpty(label) && !isEmpty(page_label)
        ? `pages/sections/banner/get/${label}/${page_label}`
        : `pages/sections/banner/get/${label}`;

    const socialNetworkUrl =
      !isEmpty(label) && !isEmpty(page_label)
        ? `pages/sections/social-network/get/${label}/${page_label}`
        : `pages/sections/social-network/get/${label}`;

    const responseBanner = await safeApiRequest(bannerUrl);
    const responseSocial = await safeApiRequest(socialNetworkUrl);

    // Validação da cor hex
    let validatedHexColor = base_hexcolor;
    if (validatedHexColor && !/^#[0-9A-F]{6}$/i.test(validatedHexColor)) {
      validatedHexColor = '#0052CC';
    }

    const retorno = {
      company: { company: { ...data?.company, base_hexcolor: validatedHexColor }, base_hexcolor: validatedHexColor },
      banner: responseBanner?.data?.data,
      social: responseSocial?.data?.data,
      base_hexcolor: validatedHexColor,
      vacancy: data,
      logo_url: logo_url,
      favicon_url: favicon_url,
      currentLabel: currentLabel,
      error,
      isMobile,
      past,
      finished,
      utm_source,
      utm_campaign,
      utm_medium,
      query,
    };

    canonical = process.env.REACT_APP_URL + '/' + currentLabel + '/vacancy/' + query.slug;

    if (retorno.vacancy.remote !== 1) {
      job_location = {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressLocality:
            retorno.vacancy.show_location === 1 &&
            retorno.vacancy.remote === 0 &&
            retorno.vacancy.city !== ''
              ? retorno.vacancy.city
              : '',
          addressRegion:
            retorno.vacancy.show_location === 1 &&
            retorno.vacancy.remote === 0 &&
            retorno.vacancy.state !== ''
              ? retorno.vacancy.state
              : '',
          addressCountry:
            retorno.vacancy.show_location === 1 &&
            retorno.vacancy.remote === 0 &&
            retorno.vacancy.country !== ''
              ? retorno.vacancy.country
              : '',
        },
      };
      job_location_type = 'jobLocation';
    } else {
      job_location = 'TELECOMMUTE';
      job_location_type = 'jobLocationType';
    }

    return { retorno };
  } catch (err) {
    // Log do erro principal apenas em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      console.error('Error in Details.getInitialProps:', err);
    }
    
    const retorno = {
      error: true,
      error_message: err,
    };
    return { retorno };
  }
};

export default withGA('UA-143354369-8', Router)(Details);
